/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Free ${i?.label} typing test. Measure your typing speed (WPM) and accuracy over a ${i?.label} session. No signup, works in your browser.`)
};

const es_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test de mecanografía gratis de ${i?.label}. Mide tu velocidad de escritura (WPM) y precisión en una sesión de ${i?.label}. Sin registro, funciona en tu navegador.`)
};

const de_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostenloser ${i?.label} Tipptest. Miss deine Tippgeschwindigkeit (WPM) und Genauigkeit in einer ${i?.label}-Sitzung. Keine Anmeldung, läuft direkt im Browser.`)
};

const nl_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gratis typetest van ${i?.label}. Meet je typsnelheid (WPM) en nauwkeurigheid tijdens een sessie van ${i?.label}. Geen aanmelding, werkt in je browser.`)
};

const fr_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test de frappe gratuit de ${i?.label}. Mesurez votre vitesse de frappe (WPM) et votre précision sur une session de ${i?.label}. Sans inscription, fonctionne dans votre navigateur.`)
};

const it_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test di digitazione da ${i?.label} gratuito. Misura la tua velocità di digitazione (WPM) e la precisione in una sessione da ${i?.label}. Nessuna registrazione, funziona nel browser.`)
};

const pt_br2_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teste de digitação de ${i?.label} grátis. Meça sua velocidade de digitação (WPM) e precisão em uma sessão de ${i?.label}. Sem cadastro, funciona no seu navegador.`)
};

const pt_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teste de escrita de ${i?.label} gratuito. Meça a sua velocidade de escrita (WPM) e precisão numa sessão de ${i?.label}. Sem registo, funciona no seu navegador.`)
};

const ja_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無料の${i?.label}タイピングテスト。${i?.label}のセッションでタイピング速度（WPM）と正確率を測定します。登録不要、ブラウザで動作。`)
};

const zh_typing_variant_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费${i?.label}打字测试。在${i?.label}的测试中测量您的打字速度（WPM）和准确率。无需注册，可在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_meta_description = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_meta_description", locale)
	if (locale === "en") return en_typing_variant_meta_description(inputs)
	if (locale === "es") return es_typing_variant_meta_description(inputs)
	if (locale === "de") return de_typing_variant_meta_description(inputs)
	if (locale === "nl") return nl_typing_variant_meta_description(inputs)
	if (locale === "fr") return fr_typing_variant_meta_description(inputs)
	if (locale === "it") return it_typing_variant_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_meta_description(inputs)
	if (locale === "pt") return pt_typing_variant_meta_description(inputs)
	if (locale === "ja") return ja_typing_variant_meta_description(inputs)
	return zh_typing_variant_meta_description(inputs)
};